import React from "react";

export const StatusDot = ({ color }) => {
  return (
    <span
      style={{
        display: "inline-block",
        width: "12px",
        height: "12px",
        borderRadius: "50%",
        backgroundColor: color,
        marginLeft: "6px",
        animation: "pulse 1.2s infinite ease-in-out"
      }}
    />
  );
};